__turbopack_context__.v({
  "avatar": "Avatars-module__ADpFiW__avatar",
  "avatarSm": "Avatars-module__ADpFiW__avatarSm",
  "cardHeader": "Avatars-module__ADpFiW__cardHeader",
  "cardHeaderActions": "Avatars-module__ADpFiW__cardHeaderActions",
  "container": "Avatars-module__ADpFiW__container",
  "genericPlaceholder": "Avatars-module__ADpFiW__genericPlaceholder",
  "genericRow": "Avatars-module__ADpFiW__genericRow",
  "grid": "Avatars-module__ADpFiW__grid",
  "initials": "Avatars-module__ADpFiW__initials",
  "initialsLarge": "Avatars-module__ADpFiW__initialsLarge",
  "noHover": "Avatars-module__ADpFiW__noHover",
  "primaryCard": "Avatars-module__ADpFiW__primaryCard",
  "primaryDetailContainer": "Avatars-module__ADpFiW__primaryDetailContainer",
  "primaryGenderAge": "Avatars-module__ADpFiW__primaryGenderAge",
  "primaryLeft": "Avatars-module__ADpFiW__primaryLeft",
  "primaryMeta": "Avatars-module__ADpFiW__primaryMeta",
  "primaryName": "Avatars-module__ADpFiW__primaryName",
  "primaryRole": "Avatars-module__ADpFiW__primaryRole",
  "primarySummary": "Avatars-module__ADpFiW__primarySummary",
  "sectionTitle": "Avatars-module__ADpFiW__sectionTitle",
  "smallCard": "Avatars-module__ADpFiW__smallCard",
  "smallCardEmpty": "Avatars-module__ADpFiW__smallCardEmpty",
  "smallCards": "Avatars-module__ADpFiW__smallCards",
  "smallMeta": "Avatars-module__ADpFiW__smallMeta",
  "smallName": "Avatars-module__ADpFiW__smallName",
  "smallRole": "Avatars-module__ADpFiW__smallRole",
  "smallRow": "Avatars-module__ADpFiW__smallRow",
  "smallSummary": "Avatars-module__ADpFiW__smallSummary",
  "typeBadgeExploratory": "Avatars-module__ADpFiW__typeBadgeExploratory",
  "typeBadgePrimary": "Avatars-module__ADpFiW__typeBadgePrimary",
  "typeBadgeSecondary": "Avatars-module__ADpFiW__typeBadgeSecondary",
});
